import {FilterActionOperation, FilterConfig, FilterTypes} from '@hconnect/common/maintain-filters'

import {useGetStoppagePlants} from './hooks/useGetStoppagePlants'

const planCountry: FilterConfig = {
  id: 'plantId',
  label: 'Plant',
  type: FilterTypes.Select,
  available: true,
  optionsLoader: useGetStoppagePlants
}

const stoppageTime: FilterConfig = {
  id: 'start',
  label: 'stoppage.detail.time',
  type: FilterTypes.Date,
  rangeAvailable: true,
  available: true
}

const rcfaDuration: FilterConfig = {
  id: 'rcfaDuration',
  label: 'stoppage.detail.duration',
  type: FilterTypes.Text,
  available: true,
  operation: FilterActionOperation.GREATER_OR_EQUAL,
  hidden: true
}

export const getAvailableStoppageFilters = (): Array<FilterConfig> => {
  const baseFilters: FilterConfig[] = [planCountry, stoppageTime, rcfaDuration]
  return baseFilters
}
